module.exports = __webpack_public_path__ + "img/np_fluctuation_2582357_F0CD5E.8018710a.svg";